/**
 * Ayrılma hali eki, kesme işaretiyle: "Masa 47'den", "Masa 45'ten",
 * "Bahçe'den", "Teras'tan" (23 Eki 2026, mutfak kartındaki taşıma notu).
 * Sayıyla biten adda ek sayının okunuşuna göre.
 */
const FRONT = 'eiöü'
const BACK = 'aıou'
const HARD = 'fstkçşhp'

/** Sayının okunuşunun son hecesi: ünlüsü ve sert sessizle bitip bitmediği. */
function numberTail(digits: string): { vowel: string; hard: boolean } {
  const n = digits.replace(/^0+(?=\d)/, '')
  const zeros = n.length - n.replace(/0+$/, '').length
  const last = n.replace(/0+$/, '')
  if (n === '0') return { vowel: 'ı', hard: false } // sıfır
  if (zeros >= 9) return { vowel: 'a', hard: false } // milyar
  if (zeros >= 6) return { vowel: 'o', hard: false } // milyon
  if (zeros >= 3) return { vowel: 'i', hard: false } // bin
  if (zeros === 2) return { vowel: 'ü', hard: false } // yüz
  if (zeros === 1) {
    const tens: Record<string, { vowel: string; hard: boolean }> = {
      '1': { vowel: 'o', hard: false }, // on
      '2': { vowel: 'i', hard: false }, // yirmi
      '3': { vowel: 'u', hard: false }, // otuz
      '4': { vowel: 'ı', hard: true }, // kırk
      '5': { vowel: 'i', hard: false }, // elli
      '6': { vowel: 'ı', hard: true }, // altmış
      '7': { vowel: 'i', hard: true }, // yetmiş
      '8': { vowel: 'e', hard: false }, // seksen
      '9': { vowel: 'a', hard: false }, // doksan
    }
    return tens[last.slice(-1)]
  }
  const ones: Record<string, { vowel: string; hard: boolean }> = {
    '1': { vowel: 'i', hard: false }, // bir
    '2': { vowel: 'i', hard: false }, // iki
    '3': { vowel: 'ü', hard: true }, // üç
    '4': { vowel: 'ö', hard: true }, // dört
    '5': { vowel: 'e', hard: true }, // beş
    '6': { vowel: 'ı', hard: false }, // altı
    '7': { vowel: 'i', hard: false }, // yedi
    '8': { vowel: 'e', hard: false }, // sekiz
    '9': { vowel: 'o', hard: false }, // dokuz
  }
  return ones[last.slice(-1)]
}

export function ablative(name: string): string {
  const text = name.trim()
  if (!text) return text
  const num = /(\d+)$/.exec(text)
  let vowel = ''
  let hard = false
  if (num) {
    ;({ vowel, hard } = numberTail(num[1]))
  } else {
    const lower = text.toLocaleLowerCase('tr-TR')
    for (let i = lower.length - 1; i >= 0; i--) {
      if (FRONT.includes(lower[i]) || BACK.includes(lower[i])) {
        vowel = lower[i]
        break
      }
    }
    hard = HARD.includes(lower[lower.length - 1])
  }
  const d = hard ? 't' : 'd'
  const v = FRONT.includes(vowel) ? 'e' : 'a'
  return `${text}'${d}${v}n`
}
